<div class="opt-dialog" *ngIf="!loading">
  <!-- Header -->
  <div class="opt-dialog__header">
    <button class="opt-dialog__close" (click)="close()">
      <i class="material-icons">close</i>
    </button>
    <div class="opt-dialog__item-info">
      <img *ngIf="item.imageData" class="opt-dialog__item-img" [src]="item.imageData" alt=""/>
      <div class="opt-dialog__item-placeholder" *ngIf="!item.imageData">
        <i class="material-icons">restaurant</i>
      </div>
      <div class="opt-dialog__item-details">
        <h2 class="opt-dialog__item-name">{{item.name}}</h2>
        <span class="opt-dialog__item-price">${{(item.price / 100).toFixed(2)}}</span>
      </div>
    </div>
    <div class="opt-dialog__qty">
      <button class="opt-dialog__qty-btn" (click)="minus()" [disabled]="quantity <= 1">
        <i class="material-icons">remove</i>
      </button>
      <span class="opt-dialog__qty-val">{{quantity}}</span>
      <button class="opt-dialog__qty-btn opt-dialog__qty-btn--add" (click)="plus()">
        <i class="material-icons">add</i>
      </button>
    </div>
  </div>

  <!-- Modifiers -->
  <div class="opt-dialog__content">
    <mat-error class="opt-dialog__error" *ngIf="selectionError">Please select the required options</mat-error>

    <div class="opt-dialog__spinner" *ngIf="modifiers_loading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>

    <div *ngIf="!modifiers_loading">
      <div *ngFor="let modifierGroup of modifierGroups; let i = index" class="opt-dialog__group">
        <div class="opt-dialog__group-header">
          <span class="opt-dialog__group-name">{{modifierGroup.name}}</span>
          <span class="opt-dialog__group-req" *ngIf="modifierGroup.minRequired > 0">Required</span>
          <span class="opt-dialog__group-info" *ngIf="modifierGroup.maxAllowed > 0">
            Pick up to {{modifierGroup.maxAllowed}}
          </span>
        </div>
        <div class="opt-dialog__modifiers">
          <button *ngFor="let modifier of modifierGroup.modifiers"
                  class="opt-dialog__mod-chip"
                  [ngClass]="{'opt-dialog__mod-chip--selected': modifier.checked, 'opt-dialog__mod-chip--disabled': isModifierDisabled(modifierGroup, modifier)}"
                  [disabled]="isModifierDisabled(modifierGroup, modifier)"
                  (click)="toggleModifier(i, modifier, modifierGroup.maxAllowed)">
            <i class="material-icons opt-dialog__mod-check" *ngIf="modifier.checked">check_circle</i>
            <span class="opt-dialog__mod-name">{{modifier.name}}</span>
            <span class="opt-dialog__mod-price" *ngIf="modifier.price > 0">+${{(modifier.price / 100).toFixed(2)}}</span>
            <span class="opt-dialog__mod-price opt-dialog__mod-price--free" *ngIf="!modifier.price || modifier.price === 0">Free</span>
          </button>
        </div>
      </div>

      <!-- Custom Modifier (Manager, Admin, Server only) -->
      <ng-container *ngIf="canAddCustomModifier">
        <div class="opt-dialog__group" *ngIf="!showCustomModInput">
          <button class="opt-dialog__add-custom" (click)="showCustomModInput = true">
            <i class="material-icons">add_circle_outline</i> Add Custom Modifier
          </button>
        </div>
        <div class="opt-dialog__group" *ngIf="showCustomModInput">
          <div class="opt-dialog__group-header">
            <span class="opt-dialog__group-name">Custom Modifier</span>
          </div>
          <div class="opt-dialog__custom-mod">
            <input type="text" [(ngModel)]="customModName" placeholder="Name (e.g. Extra sauce)" class="opt-dialog__custom-input"/>
            <div class="opt-dialog__custom-price-row">
              <span>$</span>
              <input type="number" [(ngModel)]="customModPrice" placeholder="0.00" step="0.01" min="0" class="opt-dialog__custom-input opt-dialog__custom-input--price"/>
              <button class="opt-dialog__custom-add-btn" [disabled]="!customModName?.trim()" (click)="addCustomModifier()">Add</button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Note -->
      <div class="opt-dialog__group">
        <div class="opt-dialog__group-header">
          <span class="opt-dialog__group-name">{{ canAddCustomModifier ? 'Special Instructions' : 'Note for the Chef' }}</span>
        </div>
        <textarea class="opt-dialog__note" [(ngModel)]="customNote"
                  [placeholder]="canAddCustomModifier ? 'Any special requests...' : 'Leave a note for the chef (e.g. no onions, extra spicy...)'"></textarea>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="opt-dialog__footer">
    <div class="opt-dialog__running-total">
      <span>Total:</span>
      <span>${{getRunningTotal()}}</span>
    </div>
    <button class="opt-dialog__add-btn" (click)="addToCart()">
      Add to Cart &mdash; ${{getRunningTotal()}}
    </button>
  </div>
</div>

<!-- Loading -->
<div class="opt-dialog__loading" *ngIf="loading">
  <mat-spinner diameter="32"></mat-spinner>
  <p>Loading options...</p>
</div>
